import { UserPreferences as UserPreferencesPage } from "@/pages";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/user/preferences")({
  component: UserPreferencesPage,
  beforeLoad: () => {
    document.title = "Maifud - Preferencias";
  },
});
